// react
import React from 'react'

// dependencies
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { Form } from '@st-operations/uikit/src/v2/index.js'
import EntityEditForm from '_components/entity-edit-form/index.jsx'

// style
import '../../css/pages/DataFeed.styl'

const DataFeed = (props) => {
  const [modalState, setModalState] = React.useState(false)

  const toggleModal = () => {
    setModalState((prevState) => !prevState)
  }

  const onSave = () => {
    toast('Distributing changes to s3!')

    // upload to s3
    window._api.put('/data-feeds/distribute', {}, (error) => {
      if (error) {
        toast.error(error.message)
      } else {
        toast('Changes distributed to s3!')
      }
    })
  }

  const handleChange = (onChange) => (e, name, value, saveOnChange) => {
    onChange(e, name, value, saveOnChange)
  }

  const handleStopFeed = () => {
    window._api.put(`/data-feeds/${props.match.params.id}`, { status: 'archived' }, (error) => {
      if (error) {
        toast.error(error.message)
      }
    })
  }

  const handleStartFeed = () => {
    window._api.put(`/data-feeds/${props.match.params.id}`, { status: 'processed' }, (error) => {
      if (error) {
        toast.error(error.message)
      }
    })
  }

  return (
    <div id="data-feed-page" className="data-feed-page">
      <EntityEditForm
        name="feed"
        entities="data-feeds"
        id={props.match.params.id}
        resource="Data Feeds"
        onSave={onSave}
        actions={[
          {
            children: 'Export',
            onClick: toggleModal,
            theme: BUTTON_THEME.SECONDARY,
          },
        ]}
        className="st-data-feed__entity-edit-form"
      >
        {({ disabled, item, onChange, schema }) => (
          <>
            <Choose>
              <When condition={item.status === 'approved' || item.status === 'processed'}>
                <Button
                  onClick={handleStopFeed}
                  className="data-feed-page__stop-button"
                  theme={BUTTON_THEME.GHOST}
                >
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="8" height="8" rx="1" fill="#FF2710" />
                  </svg>
                  <p className="data-feed-page__stop-button-text">Stop feed</p>
                </Button>
              </When>
              <Otherwise>
                <Button
                  onClick={handleStartFeed}
                  className="data-feed-page__start-button"
                  theme={BUTTON_THEME.SECONDARY}
                >
                  Start feed
                </Button>
              </Otherwise>
            </Choose>
            <TabbedViews key={item._id}>
              <Form
                title="Metadata"
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[{ name: 'name' }, { name: 'client' }]}
                disabled={disabled}
              />

              <Form
                title="Content Selection"
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[
                  {
                    group: true,
                    className: 'data-feed-page__flex',
                    fields: [
                      { name: 'type' },
                      { name: 'sample_start_date' },
                      { name: 'sample_end_date' },
                    ],
                  },
                  {
                    // eslint-disable-next-line react/display-name
                    render: (props) => <FileInput onDrop={handleChange(onChange)} {...props} />,
                  },
                  { name: 'events' },
                  { name: 'fields', prettify: false },
                  { name: 'dedupe_feeds' },
                  { name: 'dedupe_interval' },
                  { name: 'dedupe_fields' },
                ]}
                disabled={disabled}
              />

              <Form
                title="File Configuration"
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[
                  { name: 'geos', optionAll: 'Global' },
                  { name: 'excluded_geos', optionAll: 'Global' },
                  { name: 'mapping_id' },
                  { name: 'compression' },
                  { name: 'file_naming_format' },
                  { name: 'num_files' },
                  { name: 'partition_type' },
                  { name: 'time_format' },
                ]}
                disabled={disabled}
              />

              <Form
                title="Delivery Configuration"
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[
                  { name: 'access_method' },
                  { name: 'interval' },
                  { name: 'remote_s3_path' },
                  { name: 's3_access_key_id' },
                  { name: 's3_bucket' },
                  { name: 's3_secret_access_key' },
                ]}
                disabled={disabled}
              />
            </TabbedViews>
          </>
        )}
      </EntityEditForm>

      <Dialog open={modalState} close={toggleModal}>
        <ExportDataFeedDialog onClose={toggleModal} />
      </Dialog>
    </div>
  )
}

export default DataFeed
